import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { OrderJSON } from '@app/@shared/orderjson.model';
import { SessionStorageService } from '@app/sessionStorage.service';

export const subscriptionSelectionGuard: CanActivateFn = (): boolean | UrlTree => {
  const router = inject(Router);
  const sessionStorageService = inject(SessionStorageService);
  const token = sessionStorage.getItem('token');

  if (!token) {
    return true;
  }

  const completedOrder = sessionStorageService.getAllData(SessionStorageService.EXISTING_ORDER_FLOW);
  if (completedOrder && Object.keys(completedOrder).length > 0) {
    return router.createUrlTree(['/account-portal']);
  }

  const order = sessionStorageService.getAllData() as OrderJSON;
  const resumeRoute = order?.subscriptionType === 'POS+' ? '/business-information' : '/business-information2';
  return router.createUrlTree([resumeRoute]);
};